import { createRoot } from "react-dom/client";
import * as styles from "@common/EmbedHome.module.scss";
import HeaderEmbed from "@common/HeaderEmbed";
import App from "./App";

document.addEventListener("DOMContentLoaded", function () {
  const searchParams = new URLSearchParams(window.location.search);
  const lang = document.documentElement.lang || "ca";
  const preview = searchParams.get("preview") === "1";
  const slug = searchParams.get("slug");
  const containers = document.querySelectorAll(".embed-mapa-renda-catalunya");
  containers.forEach((container) => {
    const embedHome =
      searchParams.get("embed-home") === "1" ||
      container.dataset.embedHome === "1";
    if (embedHome) {
      container.classList.add(styles.containerHome);
    }
    const root = createRoot(container);
    root.render(
      <>
        {preview && <HeaderEmbed allowHomeEmbed={false} />}
        <App
          lang={lang}
          embedHome={embedHome}
          slug={slug || container.dataset.slug || null}
        />
      </>,
    );
  });
});
